/**
 * Superadmin frontend konstantalari.
 *
 * ALL_MODULE_KEYS_FRONTEND — backend models/enterprise.py ALL_MODULE_KEYS bilan sinxron.
 * Backend o'zgarganda bu ham yangilanishi kerak.
 */

export const ALL_MODULE_KEYS_FRONTEND: string[] = [
  "catalog",
  "customers",
  "orders",
  "stock",
  "finance",
  "delivery",
  "attendance",
  "gps",
  "contracts",
  "tickets",
  "promo",
  "stats",
  "push",
  "pos",
  "marketplace",
];
